import React from "react";
import "./Loader.scss";

const Loader = () => {
    return (
        <div className="loader-modal">
            <div className="loader centered" />
        </div>
    );
};

export default Loader;